export default "__VITE_ASSET__673e3d7c__"